// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","container":"Header_container__vI36D","nav":"Header_nav__J8WFt","exit":"Header_exit__QnsIX","logo":"Header_logo__UsziS","arrow":"Header_arrow__UOjtE"};